<template>
	<img
		:src="impressionTag"
		style="display: none"
		border="0"
		height="1"
		width="1"
		alt="Advertisement"
		@load="$emit('pixelFired', 200)"
		@error="$emit('pixelFired', 418)"
	/>
</template>

<script setup lang="ts">
defineProps<{ impressionTag: string }>();

defineEmits<{ (e: 'pixelFired', status: number): void }>();
</script>
